import { render } from "./vgpQuillEditor.vue?vue&type=template&id=4cecf6c9"
import script from "./vgpQuillEditor.vue?vue&type=script&lang=js"
export * from "./vgpQuillEditor.vue?vue&type=script&lang=js"

import "./vgpQuillEditor.vue?vue&type=style&index=0&id=4cecf6c9&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__